import { componentInterface } from '@ardoq/component-interface';
import { colors } from '@ardoq/design-tokens';
import { GraphItem, isCollapsibleGroup } from '@ardoq/graph';
import { HtmlCanvasVisual, IEdge, ILabel, IRenderContext } from '@ardoq/yfiles';
import { readableButtonColor } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/utils';
import { MODERNIZED_BLOCK_DIAGRAM_URL_ICON_SIZE as ICON_SIZE } from './modernized/consts';
import { drawSpriteIcon } from 'tabview/blocks/visual/node/drawSpriteIcon';
import { IconName } from '@ardoq/icons';
import { isPureGraphNodeOrGroup } from './modernized/leafNode/util';

const getUrlLabelBackgroundColor = (graphItem: GraphItem): string => {
  const modelId = graphItem.modelId;

  const isGroup = isCollapsibleGroup(graphItem);
  const hasAllDataInClassProperties = isPureGraphNodeOrGroup(graphItem);

  const isComponent = hasAllDataInClassProperties
    ? graphItem.isComponent()
    : componentInterface.isComponent(modelId);

  const isNotCollapsedComponentGroup =
    isGroup && !(isComponent && graphItem.collapsed);

  if (isNotCollapsedComponentGroup) {
    return colors.white950;
  }

  if (!modelId) {
    return colors.grey50;
  }

  const fill = hasAllDataInClassProperties
    ? graphItem.getCssColorAttributes().fill
    : componentInterface.getComponentDisplayColorAsSVGAttributes(modelId, {
        useAsBackgroundStyle: false,
      })?.fill;

  return fill || colors.grey50;
};

class UrlLabelVisual extends HtmlCanvasVisual {
  constructor(private label: ILabel) {
    super();
  }
  override render(_: IRenderContext, ctx: CanvasRenderingContext2D): void {
    const {
      tag,
      owner,
      layout: {
        bounds: { x, y },
      },
    } = this.label;
    const graphItem = tag as GraphItem;

    const { isTransparentized } = graphItem;
    const globalAlpha = ctx.globalAlpha;
    ctx.globalAlpha = isTransparentized ? 0.32 : 1;

    const isGroup = isCollapsibleGroup(graphItem);
    const backgroundColor = getUrlLabelBackgroundColor(graphItem);
    const urlIconColor = isGroup
      ? readableButtonColor(backgroundColor)
      : colors.grey500;

    const isEdge = owner instanceof IEdge;
    if (isEdge) {
      // edges get a white background. otherwise the edge line would be visible inside the icon, which is ugly.
      ctx.fillStyle = colors.white950;
      ctx.fillRect(x, y, ICON_SIZE, ICON_SIZE);
    }
    drawSpriteIcon(
      IconName.OPEN_IN_NEW,
      ICON_SIZE,
      urlIconColor,
      x + ICON_SIZE / 2,
      y + ICON_SIZE / 2,
      ctx
    );
    ctx.globalAlpha = globalAlpha;
  }
}
export { UrlLabelVisual };
